import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Egyptian National ID validator following Single Responsibility Principle
 */
export class EgValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Egyptian National ID',
      pattern: /^\d{14}$/,
      length: 14
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Egyptian ID must be exactly 14 digits'
    );
  }

  validateChecksum(id) {
    // Egyptian ID structure validation
    const century = id.substring(0, 1);
    const year = id.substring(1, 3);
    const month = id.substring(3, 5);
    const day = id.substring(5, 7);
    const governorate = id.substring(7, 9);
    
    // Validate century (2 for 1900s, 3 for 2000s)
    if (century !== '2' && century !== '3') {
      return ValidationResult.invalid('Invalid century code');
    }
    
    // Validate month
    if (parseInt(month) < 1 || parseInt(month) > 12) {
      return ValidationResult.invalid('Invalid birth month');
    }
    
    // Validate day
    if (parseInt(day) < 1 || parseInt(day) > 31) {
      return ValidationResult.invalid('Invalid birth day');
    }

    return ValidationResult.valid('Valid Egyptian ID');
  }
}